export default {
  id: "ledger",
  type: "ledger",
  icon: "balance-scale-right",
  text: "Partitario",
  mainParams: ["fromDate", "toDate", "accountId"],
  header: {
    rows: [
      {
        type: "row",
        items: [
          /* {
            type: "autocomplete",
            id: ["accountId", "accountTitle"],
            label: "Seleziona conto",
            initValue: ["", ""],
          },*/
          {
            type: "accountsList",
            id: ["accountId", "accountName"],
            label: "Seleziona conto",
            initValue: ["", ""]
          },
          {
            type: "rangedate",
            id: ["fromDate", "toDate"],
            label: "Seleziona periodo",
            initValue: [null, null]
          }
        ]
      }
    ]
  },
  groupBy: ["balanceSheet", "incomeStatement"]
};
